class FlipCard extends HTMLElement {
  constructor() {
    super();
    this.card = this.querySelector('.flip-card');
    this.isTouch = window.matchMedia('(hover: none)').matches;

    if (!this.card) return;

    if (this.isTouch) {
      this.card.addEventListener('click', this.handleTap.bind(this));
    }
  }

  handleTap(event) {
    if (!this.card.classList.contains('is-flipped')) {
      // First tap just reveals the back — don't let it also navigate if
      // the front happens to be wrapped in a link somewhere.
      event.preventDefault();
      this.card.classList.add('is-flipped');
      this.closeOthers();
      return;
    }

    // Already flipped: a tap directly on a real menu link should navigate
    // normally, not be intercepted.
    if (event.target.closest('a')) {
      return;
    }

    // Tapping the back anywhere else (not a link) flips it closed again.
    if (event.target.closest('.flip-card__back')) {
      event.preventDefault();
      this.card.classList.remove('is-flipped');
    }
  }

  closeOthers() {
    document.querySelectorAll('flip-card .flip-card.is-flipped').forEach((other) => {
      if (other !== this.card) other.classList.remove('is-flipped');
    });
  }
}

customElements.define('flip-card', FlipCard);
